<template>
    <div class="user-info n-plr-3 n-pt-3 n-border-box">
        <div class="n-flex n-flex-a-c">
            <div class="user-info-avatar n-c-1 n-bg-base n-radius-circle n-flex n-flex-a-c n-flex-j-c n-f-bold5 n-line-height-1 n-flex-s">{{ ((userInfo?.nickName ? userInfo?.nickName : userInfo?.email) || '').substring(0, 1).toUpperCase() }}</div>

            <div class="n-mlr-3 n-flex-g n-flex-g-w-1-hack">
                <h3 class="user-info-name n-f-bold6 n-c-4 n-f-4 n-flex n-flex-a-c n-break-word">
                    {{ userInfo?.nickName ? userInfo?.nickName : userInfo?.email }}
                </h3>
                <p class="n-f-0 n-c-2 n-mt-1">{{ getGradeText() }}</p>
            </div>

            <icon-button
                icon="edit"
                class="n-flex-s"
                type="gray"
                :size="40"
                :icon-size="20"
                @click="editUserInfo" />
        </div>

        <ul class="user-info-list n-mt-6">
            <li class="user-info-list-item n-flex n-flex-a-c">
                <router-link
                    :to="{ name: 'submitfeedback' }"
                    class="user-info-list-link n-border-box n-block n-col-1">
                    <div class="user-info-list-inner n-border-box n-col-1 n-h-1 n-flex n-flex-a-c">
                        <nicon
                            icon="edit"
                            class="n-flex-s n-c-4 user-info-icon"
                            :size="20" />
                        <span class="nav-text n-inline-block n-f-1 n-mlr-2 n-c-4 n-flex-g user-info-text">{{ $t('feedback.title') }}</span>
                        <nicon
                            icon="list-arrow-right"
                            class="n-flex-s n-c-4 user-info-icon"
                            :size="13" />
                    </div>
                </router-link>
            </li>
        </ul>

        <!-- <ul class="user-info-list">
            <li
                v-if="userInfo?.subscriptions?.subscribed"
                class="user-info-list-item n-flex n-flex-a-c n-pointer"
                @click="goStripeSubsMgmt">
                <div class="user-info-list-link n-border-box n-block n-col-1">
                    <div class="user-info-list-inner n-border-box n-col-1 n-h-1 n-flex n-flex-a-c">
                        <nicon
                            icon="app"
                            class="n-flex-s n-c-4 user-info-icon"
                            :size="20" />
                        <span class="nav-text n-inline-block n-f-1 n-mlr-2 n-c-4 n-flex-g user-info-text">{{ $t('profile.subscriptionManagement') }}</span>
                        <nicon
                            icon="list-arrow-right"
                            class="n-flex-s n-c-4 user-info-icon"
                            :size="13" />
                    </div>
                </div>
            </li>
        </ul> -->

        <nline margin="10" />

        <ul class="user-info-list">
            <li
                class="user-info-list-item n-flex n-flex-a-c n-pointer"
                @click="logout">
                <div class="user-info-list-link n-border-box n-block n-col-1">
                    <div class="user-info-list-inner n-border-box n-col-1 n-h-1 n-flex n-flex-a-c">
                        <nicon
                            icon="logout"
                            class="n-flex-s n-c-4 user-info-icon"
                            :size="20" />
                        <span class="nav-text n-inline-block n-f-1 n-mlr-2 n-c-4 n-flex-g user-info-text">{{ $t('login.logout') }}</span>
                    </div>
                </div>
            </li>
        </ul>
    </div>
</template>

<script setup lang="ts">
import { useStore } from 'vuex';
import { useRouter } from 'vue-router';
import { computed, onMounted, onUnmounted } from 'vue';
import { $loading, $notification } from '../../../utils/index';
import { getGradeText } from '../../../utils/user';
import { logEvent } from '../../../utils/utils';
import { getStripeSubsMgmtLink } from '../../../api/subs/index';

const router = useRouter();

const emit = defineEmits<{
    close: [];
}>();

const store = useStore();
const userInfo = computed(() => store.getters['user/userInfo']);

const logout = async () => {
    $loading.loading();
    logEvent('web_mine_logout_click');
    await store.dispatch('user/logout');
    router.replace({ name: 'home' });
    $loading.hide();
};

const editUserInfo = () => {
    router.push({ name: 'profile' });
};

const goStripeSubsMgmt = async () => {
    try {
        $loading.loading();
        const res = await getStripeSubsMgmtLink();
        const link = typeof res?.data === 'string' ? res.data : '';

        if (res.code == 200 && link) {
            window.open(link, '_blank', 'noopener');
        } else {
            $notification.error(res.msg || 'Failed to open subscription management');
        }
    } catch (error: any) {
        $notification.error(error?.msg || 'Failed to open subscription management');
    } finally {
        $loading.hide();
    }
};

const handleEscClose = (event: KeyboardEvent) => {
    if (event.key !== 'Escape') {
        return;
    }

    emit('close');
};

onMounted(() => {
    document.addEventListener('keydown', handleEscClose);
});

onUnmounted(() => {
    document.removeEventListener('keydown', handleEscClose);
});
</script>

<style scoped lang="scss">
.user-info {
    width: 334px;

    .user-info-avatar {
        width: 50px;
        height: 50px;
        font-size: 30px;
    }

    .user-vip {
        background-image: url('@/assets/images/login/vip-bg.png');
        background-size: 100%;
        background-repeat: no-repeat;
        background-position: center;
        height: 84px;
        width: 304px;
    }

    .free-button {
        height: 26px;
        line-height: 26px;
        padding: 0 10px;
        border-radius: 13px;
        background: linear-gradient(100.14deg, rgba(180, 141, 253, 0.91) 14.99%, rgba(129, 69, 240, 0.91) 91.51%);
        outline: none;
        box-shadow: 0px 4.29px 4.82px 1.07px #b4b2e36b;
        box-shadow: 0px -0.54px 0.54px 0.54px #ffffff80 inset;
        backdrop-filter: blur(3.2153847217559814px);
        border: 0;
    }

    .user-info-plus {
        height: 19.29px;
        position: relative;

        i {
            padding: 0 10px 0 8px;
            font-weight: 800;
            font-style: italic;
            font-size: 15.01px;
            line-height: 19.29px;
            letter-spacing: 0px;
            color: #fff;
            position: relative;
            width: 100%;
            height: 100%;
            z-index: 20;
        }

        &:before {
            border-radius: 4.29px;
            content: '';
            display: block;
            position: absolute;
            left: 0;
            top: 0;
            width: 100%;
            height: 100%;
            background: linear-gradient(90deg, #fc7263 5.7%, #ffa674 97.81%);
            z-index: 10;
        }

        &:after {
            content: '';
            display: block;
            position: absolute;
            left: 3px;
            top: 0;
            border-radius: 4.29px;
            width: 100%;
            height: 100%;
            background: linear-gradient(90.39deg, #4c4087 4.86%, rgba(76, 64, 135, 0) 91.98%);
            transform: rotateZ(5deg);
            transform-origin: top left;
            backdrop-filter: blur(2.3579487800598145px);
            opacity: 0.3;
        }
    }

    .user-info-list {
        .user-info-list-link {
            position: relative;
            height: 48px;
            text-decoration: none;

            .user-info-list-inner {
                border-radius: 16px;
                background-color: rgba(0, 0, 0, 0);
                transition: all 0.3s;
            }

            .user-info-text {
                margin-left: 8px;
                font-weight: 400;
                transition: all 0.3s;
            }

            &:hover {
                .user-info-text,
                .user-info-icon {
                    color: var(--color-base);
                }
            }
        }
    }
}

.user-info-vip-icon {
    width: 25px;
}
</style>
